import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Container from '../Container';

const ComponentLayout = ({ children, bgColor }) => {
  return (
    <div
      className="component-layout-wrapper"
      // style={{ backgroundColor: `${bgColor ? bgColor : '#f8f8f8'}` }}
    >
      <Container>{children}</Container>
    </div>
  );
};

ComponentLayout.propTypes = {
  children: PropTypes.node.isRequired,
  bgColor: PropTypes.string,
};

export default ComponentLayout;
